import cn from "classnames";
import classes from "../../ChallengeCustomizeForm.module.css";
import WithTooltip from "../../../../ui/tooltip";
import {useTranslation} from "react-i18next";
import Select from "../../../../ui/select";
import {DisplayParametricResultMode} from "../../../../schema";

export default function DisplayResultModeSelector(props: React.ComponentProps<"select"> & {}) {
  const {t} = useTranslation();

  return (
    <div className={cn(classes.formItem)}>
      <label className={classes.label}>{t("components.ChallengeCustomizeForm.displayResultMode.label")}</label>
      <WithTooltip
        className={classes.help}
        as="span"
        helpText={t("components.ChallengeCustomizeForm.displayResultMode.helpText")}
      >
        <Select {...props}>
          <option value={DisplayParametricResultMode.RAW_SUM}>{t("types.displayResultMode.RAW_SUM")}</option>
          <option value={DisplayParametricResultMode.PERCENTAGE}>{t("types.displayResultMode.PERCENTAGE")}</option>
        </Select>
      </WithTooltip>
    </div>
  );
}
